import StaticSelectFilter from "@components/common/Filters/StaticSelectFilter.jsx";
import Pagination from "@components/common/pagination";
import HistoryIcon from "@components/icons/HistoryIcon";
import { ModalKitHistory } from "@components/Modals/ModalKitHistory";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import {
	deleteselectedKit,
	fetchVesselKits,
	fetchvesselItemwithredirect,
} from "@services/vesselService.js";
import { Tooltip } from "flowbite-react";
import { debounce } from "lodash";
import { Suspense, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FLAGS } from "../../../../config/growthbook/flags.js";
import SearchInput from "../../../common/SearchInput";
import DeleteIcon from "../../../icons/DeleteIcon";
import EyeIcon from "../../../icons/EyeIcon";
import ModalDelete from "../../../Modals/ModalDelete";

const KitsNumbers = () => {
	const { t } = useTranslation("vessels");
	const [searchTerms, setSearchTerms] = useState({
		kitSerialNumber: "",
		serialNumber: "",
		simCard: "",
		sanNumber: "",
		siteName: "",
		filter: "",
		search: "",
	});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedId, setSelectedId] = useState(null);
	const [kitHistoryModalData, setKitHistoryModalData] = useState({
		open: false,
		id: null,
		kitNumber: null,
	});

	const { token, permissions, role, business_units } = useSelector((state) => state.auth.user);
	// Extract Permissions

	const vesselSiteManagement = permissions.find(
		(resource) => resource.resource_name === "vessels_site",
	);
	const vesselStarlinks = vesselSiteManagement?.providers?.find(
		(subResource) => subResource.sub_resource_name === "starlink",
	);
	const authorizedPermissions = vesselStarlinks?.permissions?.filter(
		(permission) => permission.authorized === true,
	);
	const canViewKits = authorizedPermissions?.some((permission) => permission.name === "view kits");
	const canViewKitDetails = authorizedPermissions?.some(
		(permission) => permission.name === "view kit details",
	);
	const canDeleteKit = authorizedPermissions?.some(
		(permission) => permission.name === "delete kit",
	);

	const canViewKitHistory = authorizedPermissions?.some(
		(permission) => permission.name === "view kit logs",
	);
	const isDisplayedlogsBtn =
		useFeatureIsOn(FLAGS.vessels.kitNumberList.viewLogBtnVisible) && canViewKitHistory;

	const vesselId = useSelector((state) => state.modules.vessels.selectedVessel?.id);

	const vesselskitsData = useSelector((state) => state.modules.vessels.activation?.kits);

	const loading = useSelector((state) => state.modules.vessels.activation?.kits?.loadingkits);
	const [status, setStatus] = useState(null);
	const filterOptions = [
		{ id: "1", name: "Active" },
		{ id: "0", name: "Inactive" },
	];
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const currentPage = useSelector(
		(state) => state.modules.vessels.activation?.kits?.pagination.page,
	);
	const perPage = useSelector(
		(state) => state.modules.vessels.activation?.kits?.pagination.perPage,
	);
	const totalPages = useSelector(
		(state) => state.modules.vessels.activation?.kits?.pagination.totalPage,
	);
	const totalItems = useSelector(
		(state) => state.modules.vessels.activation?.kits?.pagination.totalItems,
	);

	useEffect(() => {
		const debouncedFetch = debounce(() => {
			fetchVesselKits(vesselId, dispatch, token, navigate, 1, 10, searchTerms);
		}, 300);
		debouncedFetch();
		return () => {
			debouncedFetch.cancel();
		};
	}, [searchTerms, dispatch, token, navigate]);

	const handleSearchChange = (id, value) => {
		setSearchTerms((prevTerms) => ({
			...prevTerms,
			[id]: value,
		}));
	};

	const handleClearSearch = (id) => {
		setSearchTerms((prevTerms) => ({
			...prevTerms,
			[id]: "",
		}));
	};

	const handleSearchSubmit = (event) => {
		event.preventDefault();
	};
	const handleStatusChange = (value) => {
		setStatus(value);
		setSearchTerms((prev) => ({
			...prev,
			filter: value?.id,
		}));
	};

	const handleRowClick = (id) => {
		if (canViewKitDetails) {
			const url = `/vessel/${vesselId}/${id}`;
			navigate(url);
		}
	};

	const openModal = (id) => {
		setSelectedId(id);
		setIsModalOpen(true);
	};
	const closeModal = () => setIsModalOpen(false);

	const handleDelete = async (id) => {
		try {
			const result = await deleteselectedKit(id, token, dispatch, navigate, currentPage, perPage);
			if (result.status === "success") {
				setTimeout(async () => {
					fetchVesselKits(vesselId, dispatch, token, navigate, 1, 10, searchTerms);

					closeModal();
				}, 1500);
				const url = `/vessel/${vesselId}`;
				await fetchvesselItemwithredirect(vesselId, "", token, dispatch, navigate, url);
				return true;
			} else {
				throw new Error(result.message);
			}
		} catch (error) {
			console.error("Error deleting business unit:", error);
			throw error;
		}
	};

	const handlePageChange = (pageNumber) => {
		fetchVesselKits(vesselId, dispatch, token, navigate, pageNumber, perPage, searchTerms);
	};

	const usageDisplay = useCallback(
		(usage) => {
			if (!usage) return "N/A";
			return `${usage} GB`;
		},
		[vesselskitsData],
	);
	const openModalHistory = (id, kitNumber) => {
		setKitHistoryModalData({
			open: true,
			id,
			kitNumber,
		});
	};

	return (
		<div>
			<div className="mt-4 w-full rounded-lg border border-navbar-bg bg-navbar-bg p-6 shadow">
				<form onSubmit={handleSearchSubmit}>
					<div className="space-y-4 md:grid md:grid-cols-2 md:gap-6 md:space-y-0 lg:grid-cols-2">
						<SearchInput
							id="search"
							dataTestId="kitNumber-search"
							placeholder={t("details.kitNumber.searchPlaceholder")}
							label={t("searchBy")}
							value={searchTerms.search}
							onChange={handleSearchChange}
							onClear={handleClearSearch}
						/>
						<StaticSelectFilter
							placeholder={t("details.kitNumber.statusPlaceholder")}
							label={t("filterBy")}
							value={status}
							options={filterOptions}
							onChange={handleStatusChange}
							showSearch={false}
							optionLabel={"name"}
							optionValue={"id"}
						/>
					</div>
				</form>
			</div>

			{loading ? (
				<div className="flex h-64 items-center justify-center">
					<div className="h-32 w-32 animate-spin rounded-full border-gray-700 border-t-2 border-b-2"></div>
				</div>
			) : (
				<div className="relative mt-4 overflow-x-auto bg-navbar-bg shadow-md md:rounded-lg">
					<div className="custom-scrollbar relative grid overflow-x-auto bg-navbar-bg shadow-md md:rounded-lg">
						<table className="min-w-full text-left text-[11px] text-gray-400 sm:text-sm rtl:text-right">
							<thead className="bg-dark-blue bg-opacity-40 text-gray-400 text-xs uppercase">
								<tr>
									<th scope="col" className="w-[200px] p-2 text-start text-xs sm:text-[10px]">
										KIT SERIAL NUMBER
									</th>
									<th scope="col" className="w-[200px] p-2 text-start text-xs sm:text-[10px]">
										Total Usage
									</th>
									<th scope="col" className="w-[200px] p-2 text-start text-xs sm:text-[10px]">
										Total Standard
									</th>
									<th scope="col" className="w-[200px] p-2 text-start text-xs sm:text-[10px]">
										STATUS
									</th>
									{(!!canDeleteKit || !!canViewKitDetails) && (
										<th
											scope="col"
											className="sticky right-0 w-[200px] border-3 border-b-[#7b7b7d] bg-nav-action px-2 py-4 text-center text-[10px] text-gray-400 shadow-[inset_6px_0_6px_-6px_rgba(0,0,0,0.6)] sm:text-xs"
										>
											ACTION
										</th>
									)}
								</tr>
							</thead>
							<tbody className="border-gray-700 border-b bg-navbar-bg hover:bg-blue-gray hover:bg-opacity-40">
								{vesselskitsData?.data?.length === 0 ? (
									<tr>
										<td colSpan="4" className="h-64 px-4 py-4 text-center text-gray-500 text-xs">
											No data available
										</td>
									</tr>
								) : (
									vesselskitsData?.data?.map((vessel, index) => (
										<tr
											key={index}
											className="border-gray-700 border-b bg-navbar-bg hover:bg-blue-gray hover:bg-opacity-40"
										>
											<th
												scope="row"
												className="w-[200px] max-w-xs cursor-pointer items-center justify-center p-3 text-start font-medium text-[10px] text-white sm:text-xs"
												onClick={() => handleRowClick(vessel.id)}
											>
												{vessel.kit_number}
											</th>
											<td
												scope="row"
												className="w-[200px] max-w-xs items-center justify-center p-2 text-start text-[10px] sm:text-xs"
											>
												{usageDisplay(vessel?.this_month_subscription?.total_usage)}
											</td>
											<td
												scope="row"
												className="w-[200px] max-w-xs items-center justify-center p-2 text-start text-[10px] sm:text-xs"
											>
												{usageDisplay(vessel?.this_month_subscription?.total_standard)}
											</td>
											<td className="w-[200px] max-w-xs items-center justify-center p-2 text-start text-[10px] sm:text-xs">
												<span
													className={`me-2 rounded px-2.5 py-0.5 font-medium text-xs ${
														vessel.is_active === 1
															? "border border-green-400 bg-green-dark text-green-400"
															: "border border-red-400 bg-red-dark text-red-400"
													}`}
												>
													{vessel.is_active === 1 ? "ACTIVE" : "INACTIVE"}
												</span>
											</td>
											{(!!canDeleteKit || !!canViewKitDetails || !!isDisplayedlogsBtn) && (
												<td className="sticky right-0 z-10 min-w-[200px] items-center justify-center border-3 border-b-[#7b7b7d] bg-navbar-bg p-2 text-center shadow-[inset_5px_0_5px_-5px_rgba(0,0,0,0.5)]">
													<div>
														{isDisplayedlogsBtn && (
															<button
																type="button"
																className="me-2 rounded-xl bg-button-bg px-1 py-1 font-medium text-[10px] text-white hover:bg-button-hover focus:outline-none focus:ring-4 sm:px-2 sm:py-2 sm:text-sm"
																onClick={() => openModalHistory(vessel.id, vessel.kit_number)}
															>
																<Tooltip
																	animation="duration-150"
																	content="View Logs"
																	className="bg-tooltip-bg"
																>
																	<HistoryIcon className="h-6 w-6 text-white" />
																</Tooltip>
															</button>
														)}

														{canViewKitDetails && (
															<button
																type="button"
																className="me-2 rounded-xl bg-button-bg px-1 py-1 font-medium text-[10px] text-white hover:bg-button-hover focus:outline-none focus:ring-4 sm:px-2 sm:py-2 sm:text-sm"
																onClick={() => handleRowClick(vessel.id, vessel.kit_number)}
															>
																{" "}
																<Tooltip
																	animation="duration-150"
																	content="View Details"
																	className="bg-tooltip-bg"
																>
																	<EyeIcon className={"h-6 w-6 text-white"} />
																</Tooltip>{" "}
															</button>
														)}

														{canDeleteKit && (
															<button
																type="button"
																className={`me-2 rounded-xl px-2 py-1 font-medium text-[10px] text-white focus:outline-none focus:ring-4 sm:px-2 sm:py-2 sm:text-sm ${
																	vessel?.is_active === 1
																		? "cursor-not-allowed bg-blue-gray bg-opacity-30 opacity-50"
																		: "border-gray-700 bg-blue-gray hover:bg-blue-gray hover:bg-opacity-40 focus:ring-gray-700"
																}`}
																onClick={() => openModal(vessel?.id)}
																id={vessel?.id}
																disabled={vessel?.is_active === 1}
															>
																<Tooltip
																	animation="duration-150"
																	content="Delete"
																	className="bg-dark-blue bg-opacity-80"
																>
																	<DeleteIcon className={"h-6 w-6 text-white"} />
																</Tooltip>
															</button>
														)}
													</div>

													{isModalOpen && (
														<Suspense fallback={<div>Loading Modal...</div>}>
															<ModalDelete
																id={vessel?.id}
																isOpen={selectedId === vessel.id}
																closeModal={closeModal}
																handleDelete={() => handleDelete(selectedId)}
																name={vessel.kit_number}
															/>
														</Suspense>
													)}
												</td>
											)}
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>

					<div className="flex flex-col items-center justify-between gap-2 bg-dark-blue bg-opacity-40 px-2 pt-4 pb-4 text-blue-gray text-xs sm:flex-row sm:gap-0 sm:px-4 sm:text-sm">
						<span>
							Showing {(currentPage - 1) * perPage + 1} to{" "}
							{Math.min(currentPage * perPage, totalItems)} of {totalItems}
						</span>

						<Pagination
							currentPage={currentPage}
							totalPages={totalPages}
							onPageChange={handlePageChange}
						/>
					</div>
				</div>
			)}
			{kitHistoryModalData.open && (
				<ModalKitHistory
					isOpen
					id={kitHistoryModalData.id}
					kitNumber={kitHistoryModalData.kitNumber}
					title="Activities History"
					closeModal={() =>
						setKitHistoryModalData({
							open: false,
							id: null,
							kitNumber: null,
						})
					}
				/>
			)}
		</div>
	);
};

export default KitsNumbers;
